import { navContentStore } from "@phn/state/nav-content-store";
import { h, JSX } from "@stencil/core";
import { navStateStore } from "@phn/state/nav-state-store";
import { shopStateStore } from "@phn/state/shop-state-store";
import { finderStateStore } from "@phn/state/finder-state-store";

const NavigationDrawerLoader = (): JSX.Element | null => {
  const navigationDrawerProps = {
    navContent: { ...navContentStore.state },
    navStateContent: { ...navStateStore.state },
    shopStoreContent: { ...shopStateStore.state },
    finderStoreContent: { ...finderStateStore.state },
  };

  return (
    <phn-nd-navigation-drawer-initiater {...navigationDrawerProps}>
      <phn-nd-contextual-drawer>
        <div slot="contextual_drawer_header">
          <slot name="contextual_drawer_header"></slot>
        </div>
      </phn-nd-contextual-drawer>
    </phn-nd-navigation-drawer-initiater>
  );
};

export default NavigationDrawerLoader;
